import React, { useState } from 'react'
import { Gamepad2, Play } from 'lucide-react'
import { PhysicsSurvivalRunner } from '../../../components/game'
import { genId } from '../lib/id'
import type { GameCard } from '../types/LessonDoc'
import type { CardDef, CardEditorProps, CardPreviewProps } from './types'

const numOrUndef = (v: string) => (v ? Number(v) : undefined)

const Editor: React.FC<CardEditorProps> = ({ card, onChange }) => {
  const c = card as GameCard
  return (
    <div className="space-y-3">
      <div className="p-3 rounded-lg bg-fuchsia-50 border border-fuchsia-100 text-fuchsia-700 text-sm">
        <strong>Survival Runner</strong> — game chạy vượt chướng ngại (3 làn). Lấy câu hỏi từ ngân hàng theo <strong>Lớp / Chương / Bài</strong> (nhập đúng vị trí PPCT của bài).
      </div>
      <div className="grid grid-cols-3 gap-2">
        <div>
          <label className="text-xs font-bold text-gray-500 uppercase">Lớp</label>
          <input type="number" className="w-full p-2 border border-gray-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-200"
            value={c.lop ?? ''} onChange={(e) => onChange({ lop: numOrUndef(e.target.value) })} placeholder="11" />
        </div>
        <div>
          <label className="text-xs font-bold text-gray-500 uppercase">Chương</label>
          <input type="number" className="w-full p-2 border border-gray-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-200"
            value={c.chuong ?? ''} onChange={(e) => onChange({ chuong: numOrUndef(e.target.value) })} placeholder="1" />
        </div>
        <div>
          <label className="text-xs font-bold text-gray-500 uppercase">Bài</label>
          <input type="number" className="w-full p-2 border border-gray-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-200"
            value={c.bai ?? ''} onChange={(e) => onChange({ bai: numOrUndef(e.target.value) })} placeholder="1" />
        </div>
      </div>
      <div>
        <label className="text-xs font-bold text-gray-500 uppercase">Số câu tối đa</label>
        <input type="number" className="w-32 p-2 border border-gray-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-200"
          value={c.maxQuestions ?? ''} onChange={(e) => onChange({ maxQuestions: numOrUndef(e.target.value) })} placeholder="10" />
      </div>
    </div>
  )
}

// Không tự mount game (nặng) — hiện banner, bấm "Bắt đầu chơi" mới nạp.
// CHỈ dùng Survival Runner (game chạy); thẻ cũ 'doorquest' cũng chạy game này.
const Preview: React.FC<CardPreviewProps> = ({ card }) => {
  const c = card as GameCard
  const [playing, setPlaying] = useState(false)

  if (playing) {
    const props = { lop: c.lop, chuong: c.chuong, bai: c.bai, maxQuestions: c.maxQuestions, onExit: () => setPlaying(false) }
    return (
      <div className="rounded-xl overflow-hidden border border-fuchsia-200">
        <PhysicsSurvivalRunner {...props} />
      </div>
    )
  }

  return (
    <div className="rounded-xl border border-fuchsia-200 bg-gradient-to-br from-fuchsia-500 to-purple-600 p-6 text-white text-center">
      <Gamepad2 className="mx-auto mb-2" size={32} />
      <p className="font-bold mb-1">Survival Runner — Chạy vượt chướng ngại</p>
      <p className="text-fuchsia-100 text-sm mb-4">
        {c.lop ? `Lớp ${c.lop} · Chương ${c.chuong} · Bài ${c.bai}` : 'Chưa chọn vị trí bài'}
      </p>
      <button
        onClick={() => setPlaying(true)}
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-white text-fuchsia-700 font-bold hover:bg-fuchsia-50"
      >
        <Play size={16} /> Bắt đầu chơi
      </button>
    </div>
  )
}

export const gameCardDef: CardDef = {
  type: 'game',
  label: 'Game tương tác',
  description: 'Survival Runner — chạy vượt chướng ngại',
  icon: Gamepad2,
  color: 'bg-fuchsia-50 text-fuchsia-600',
  createDefault: (): GameCard => ({ id: genId(), type: 'game', game: 'survival', maxQuestions: 10 }),
  Editor,
  Preview,
}
